import React, { use, useState } from 'react'

import {
  Box,
  ButtonProps,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'

import { HeaderContext } from '@/context/Header'
import { useUser } from '@/react-query/user'
import { CopyContentButton } from '@/views/components/CopyContentButton/CopyContentButton'

import { EmailInput } from './EmailInput'

export const ReferralModal: React.FC<ButtonProps> = ({ ...props }) => {
  const { data: user } = useUser()
  const { referralModalDisclosure } = use(HeaderContext)

  const { isOpen, onClose } = referralModalDisclosure

  const [isMessageShown, setIsMessageShown] = useState<boolean>(false)

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={() => {
          setIsMessageShown(false)
          onClose()
        }}
        size={'xl'}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader pt={7} px={9}>
            Refer a friend
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody px={9} pb={8}>
            <Text marginBottom={'2.75rem'}>
              💰 You will earn a free month for each person who starts their
              subscription through your referral.
            </Text>
            <EmailInput setIsMessageShown={setIsMessageShown} />
            <Flex
              alignItems={'center'}
              justifyContent={'space-between'}
              mt={'2.75rem'}
              wrap={'wrap'}
              gap={5}
            >
              <Box>
                <Text>or share this link with them:</Text>
                <Text fontWeight={'bold'}>
                  {window.location.host}/join/
                  {user?.referralCode}
                </Text>
              </Box>
              <CopyContentButton
                iconColor={'black'}
                variant={'brand-solid-white'}
                textCopy="Copy"
                minW={'7rem'}
                textContent={{
                  'text/plain': `${window.location.host}/join/${user?.referralCode}`,
                }}
              />
            </Flex>
          </ModalBody>
          {isMessageShown && (
            <ModalFooter
              bg="#8B77FB"
              color="white"
              roundedBottom={'2.5rem'}
              py={8}
              px={9}
            >
              <Text>
                ✅ Thank you! You’re amazing!
                <br /> We’ll let you know when they start their subscription.
              </Text>
            </ModalFooter>
          )}
        </ModalContent>
      </Modal>
    </>
  )
}
